import { type SearchProductDataDTO } from "~/features/search/models/SearchResultsDTO";
import { type AutosuggestProductGroup } from "~/domains/navigation/types/NavigationTypes";
import { type ContentDataItem, type SrpProductData } from "~/utils/models";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { transformSrpProduct } from "~/features/search/transformers/transformSrpProduct";
import type { SearchEntry } from "~/features/search/components/Autosuggest/RecentSearches/RecentSearches";

interface ResponseData {
  results: SearchProductDataDTO[];
  totalResults: number;
  productGroups?: AutosuggestProductGroup[];
  contentItems: {
    contentData: ContentDataItem[];
  } | null;
  designationMatch: boolean;
  searchSuggestions?: SearchEntry[];
}

interface TransformedResult {
  data: SrpProductData[];
  productGroups: AutosuggestProductGroup[];
  contentItems: ContentDataItem[];
  totalResults: number;
  designationMatch: boolean;
  searchSuggestions: SearchEntry[];
}

export async function fetchAutosuggestionList(text: string, isCad?: boolean) {
  const url = getSearchEndpointURL(text, isCad);

  const res = await fetch(url, { credentials: "same-origin" });

  if (res.redirected) {
    window.location.reload();
  }

  const data = (await res.json()) as ResponseData;

  return transform(data);
}

function getSearchEndpointURL(text: string, isCad?: boolean): string {
  const searchParams = new URLSearchParams();
  searchParams.set("site", "schaeffler");

  searchParams.set("q", text);
  searchParams.set("text", text);

  const apiUrl = isCad ? resolveApiUrl("/search/quick-search") : resolveApiUrl("/search/header/autosuggest");

  return apiUrl + "?" + searchParams.toString();
}

export function transform(dto: ResponseData): TransformedResult {
  return {
    data: dto.results.map(transformSrpProduct),
    totalResults: dto.totalResults,
    productGroups: dto.productGroups ?? [],
    contentItems: dto?.contentItems?.contentData ?? [],
    designationMatch: dto?.designationMatch,
    searchSuggestions: dto?.searchSuggestions ?? [],
  };
}
